/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";
import Sheet from "./Sheet";
import Actions from "../../../../../../fluid/Actions/ActionFactory";
import { CircularProgress } from "@material-ui/core";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { CloudDownload} from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});
const styles = (theme) => ({
  badge: {
    padding: `0 ${theme.spacing.unit * 2}px`,
  },
});
class EXCELViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCellValue: null,
      activeRowNo: this.props.selectedRow,
      activeColNo: this.props.selectedCol,
      // activeSheetName: this.props.selectedSheetName || "",
    };
    this.updateActiveRowNo = this.updateActiveRowNo.bind(this);
    this.updateActiveColNo = this.updateActiveColNo.bind(this);
    // this.updateActiveSheetName = this.updateActiveSheetName.bind(this);
    this.updateActiveCell = this.updateActiveCell.bind(this);
  }

  componentDidMount() {
    //for excel whatever is passed is taken as for now in future it may contain more sheets

  //  this.getEXCELInfo();

  console.log("excel viewer props")
  console.log(this.props)
  }

  // getEXCELInfo = async () => {

  //   this.setState({
  //     minRowNo: minRowNo,
  //     maxRowNo: maxRowNo,
  //   });
  // };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedRow !== this.props.selectedRow) {
      this.setState({
        ...this.state,
        activeRowNo: this.props.selectedRow,
        selectedCellValue: null
      });
    }
    if (prevProps.selectedCol !== this.props.selectedCol) {
      this.setState({
        ...this.state,
        activeColNo: this.props.selectedCol,
        selectedCellValue: null
      });
    }
  }

  updateActiveSheetName(newSheetNoSelected) {
    this.setState({ activeSheetName: newSheetNoSelected });
  }

  updateActiveRowNo(newRowSelected) {
    console.log("udpate row no", newRowSelected);
    this.setState({ activeRowNo: newRowSelected });
  }
  updateActiveColNo(newColSelected) {
    console.log("update col no", newColSelected);
    this.setState({ activeColNo: newColSelected });
  }
  updateActiveCell(newCellValueSelected) {
    this.setState({ selectedCellValue: newCellValueSelected });
  }

  setLoadingState = (loadingState) => {
    this.setState({
      loading: loadingState,
    });
  };


  downloadFile = () => {
    Actions('http_request', {
        url : this.props.downloadUrl,
        method : 'get',
        responseType : 'blob'
    }).then(response => {
        console.log("Download Response : ", response)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.props.filename); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(err => {

    })
   
  }

  renderLoader = () => {
    if (this.state.loading || 1) {
      return (
        <ThemeProvider theme={blue_theme}>
          <CircularProgress
            size={30}
            // color="blue"
          />
        </ThemeProvider>
      );
    } else return null;
  };

  render() {
    //destructure properties
    const { activeRowNo, activeColNo, selectedCellValue } = this.state;
    const { orientation, headerRow, headerColumn } = this.props;

    return (
      <div
        className="excel-viewer"
        style={{
          width: this.props.width,
          height: this.props.height,
          position: "relative",
          whiteSpace: "nowrap",
        }}
      >
        <div
          id="cell-indices-formula-value-container"
          style={{
            right: "0",
            // height: "32px",
            display: "flex",
            flexFlow: "row",
            justifyContent: "space-between",
            padding: "0",
            backgroundColor: "#edebe9",
            overflow: "hidden",
          }}
        >
          {
              this.props.download === true && (
                  <IconButton
                      style = {{marginRight : '10px', marginLeft : '10px'}}
                      onClick={ (event) => { event.preventDefault(); this.downloadFile()} }
                  >
                      <CloudDownload></CloudDownload>
                  </IconButton>
              )
          }
          <textarea
            className="value-container"
            readOnly={true}
            value={
              this.state.selectedCellValue
                ? this.state.selectedCellValue.value || ""
                : ""
            }
            rows={2}
            style={{
              resize: "none",
              outline: "none",
              flexGrow: "2",
              width: "95%",
              backgroundColor: "#fff",
              // height: "18px",
              lineHeight: "22px",
              margin: "0 4px 0 4px",
              top: "4px",
              position: "relative",
              padding: "2px",
              color: "#444444",
              fontSize: "14px",
              textAlign: "left",
              display: "block",
            }}
          />  
          {/* {this.renderLoader()} */}
          <div></div>
        </div>
        {
          <Sheet
            //row cell
            containerHeight={this.props.height}
            activeRowNo={activeRowNo}
            activeColNo={activeColNo}
            activeCell={selectedCellValue}
            shouldIncludeHeaders = {this.props.shouldIncludeHeaders}
            headerColumn={headerColumn}
            headerRow={headerRow}
            orientation={orientation}
            updateActiveRowNo={this.updateActiveRowNo}
            updateActiveColNo={this.updateActiveColNo}
            updateActiveCell={this.updateActiveCell}
            fileLink={this.props.fileLink}
            workSheets={this.props.workSheets}
            selectedWorkSheetName={this.props.selectedWorkSheetName}
            drlUrl={this.props.drlUrl}
            setLoadingState={this.setLoadingState}
            fileType={this.props.fileType}
          ></Sheet>
        }
        {/* sheet selector commented for now later can be used*/}
        {/* <SheetSelector
          activeSheetName={activeSheetName}
          sheetNameList={sheetNameList}
          updateActiveSheetName={this.updateActiveSheetName}
        ></SheetSelector> */}
      </div>
    );
  }
}

export default withStyles(styles)(EXCELViewer);
